import { useSessionSync } from '../shared/hooks/useSessionSync';

export const SessionSyncProvider = () => {
    useSessionSync();
    return null; // No UI, just side effects
};